export default function IconYouTube({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.41 9.26005C29.2507 8.66809 28.9387 8.12836 28.5052 7.69489C28.0717 7.26141 27.532 6.94939 26.94 6.79005C24.76 6.20005 16 6.20005 16 6.20005C16 6.20005 7.24002 6.20005 5.06002 6.79005C4.46806 6.94939 3.92833 7.26141 3.49485 7.69489C3.06138 8.12836 2.74936 8.66809 2.59002 9.26005C2.18297 11.4833 1.98543 13.7399 2.00002 16.0001C1.98543 18.2602 2.18297 20.5168 2.59002 22.7401C2.74936 23.332 3.06138 23.8717 3.49485 24.3052C3.92833 24.7387 4.46806 25.0507 5.06002 25.21C7.24002 25.8 16 25.8 16 25.8C16 25.8 24.76 25.8 26.94 25.21C27.532 25.0507 28.0717 24.7387 28.5052 24.3052C28.9387 23.8717 29.2507 23.332 29.41 22.7401C29.8171 20.5168 30.0146 18.2602 30 16.0001C30.0146 13.7399 29.8171 11.4833 29.41 9.26005ZM13.2 20.2001V11.8001L20.47 16.0001L13.2 20.2001Z"
                fill="currentColor"
            />
        </svg>
    )
}
